module.exports = __webpack_public_path__ + "static/media/Yovie Music School.477ef858.PNG";